"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";
import PalettePanel from "../ui/overlays/PalettePanel";
import PaletteButton from "./PaletteButton";

//===================================================
//
// Constructor
//
//===================================================

function Tutorial() {
    PIXI.Container.call(this);


    // Enumerators.
    this.STATE = {
        DRAW: 0,
        TOOL: 1,
        PALETTE: 2,
        IDLE: 3
    };


    // Constants.
    this.TUT_STEP_DELAY = 3;


    // Attributes.
    this._isPaused = false;
    this._tutorialStepTimer = 0;
    this._tutorialHand = null;
    this._state = this.STATE.IDLE;
    this._arrEvent = [];
    this._arrTutorialStep = [
        {
            state: this.STATE.DRAW,
            isValid: false,
            isDone: !Common.savedData.isDrawTutorial
        },
        {
            state: this.STATE.TOOL,
            isValid: true,
            isDone: !Common.savedData.isToolTutorial
        },
        {
            state: this.STATE.PALETTE,
            isValid: false,
            isDone: !Common.savedData.isPaletteTutorial
        }];


    // Signals.
    this.signals = {};
    this.signals.onCompleted = new signals.Signal();
}

export default Tutorial;
//module.exports = Tutorial;
Tutorial.prototype = Object.create(PIXI.Container.prototype);
Tutorial.prototype.constructor = Tutorial;


//===================================================
//
// Public
//
//===================================================

Tutorial.prototype.init = function () {
 
    this._tutorialHand = new PIXI.spine.Spine(Common.assets.spineData("tutorial_hand"));
    this._tutorialHand.skeleton.setToSetupPose();
    this._tutorialHand.skeleton.setSkin(null);
    this._tutorialHand.skeleton.setSkinByName("default");
    this._tutorialHand.autoUpdate = false;
    this._tutorialHand.scale = new PIXI.Point(0.7, 0.7);
    this._tutorialHand.alpha = 0;
    this.addChild(this._tutorialHand);

    this._tutorialHand.state.setAnimationByName(0, "still_" + ( P3.Device.isMobile ? "mobile" : "desktop" ), true);
    this._tutorialHand.update(deltaTime);
};

Tutorial.prototype.end = function () {
    this.removeChild(this._tutorialHand);
    this._tutorialHand.destroy();
    this._tutorialHand = null;
};

Tutorial.prototype.update = function () {
    if (this._tutorialHand == null) return;


    this._tutorialHand.update(deltaTime);

    this._processEvents();

    // Delayed tutorial step activation.
    if (!this._isPaused) {
        this._tutorialStepTimer += deltaTime;
        if (this._tutorialStepTimer >= this.TUT_STEP_DELAY && this._state == this.STATE.IDLE) {
            for (var tutorialStep of this._arrTutorialStep) {
                if (tutorialStep.isValid && !tutorialStep.isDone) {
                    this._state = tutorialStep.state;

                    switch (this._state) {
                        case this.STATE.DRAW:
                        {
                            this._tutorialHand.state.setAnimationByName(0, "drag_" + ( P3.Device.isMobile ? "mobile" : "desktop" ), true);
                            this._tutorialHand.position = new PIXI.Point(Common.STAGE_WIDTH * 0.5, Common.STAGE_HEIGHT * 0.5);

                            this._showHand();

                            break;
                        }

                        case this.STATE.TOOL:
                        {
                            this._tutorialHand.state.setAnimationByName(0, "tap_" + ( P3.Device.isMobile ? "mobile" : "desktop" ), true);
                            this._tutorialHand.position = Common.game.hud.getBrushBtnPosition();

                            this._showHand();

                            break;
                        }

                        case this.STATE.PALETTE:
                        {
                            this._tutorialHand.state.setAnimationByName(0, "tap_" + ( P3.Device.isMobile ? "mobile" : "desktop" ), true);
                            this._tutorialHand.position = Common.game.hud.getPaletteBtnPosition();

                            this._showHand();

                            break;
                        }
                    }
                }

                if (!tutorialStep.isDone)
                    break;
            }

            this._tutorialStepTimer = 0;
        }
    }
};

Tutorial.prototype.addEvent = function (tutorialEvent) {
    this._arrEvent.push(tutorialEvent);
};

Tutorial.prototype.resize = function () {
    if (this._tutorialHand == null) return;


    if (this._state == this.STATE.DRAW)
        this._tutorialHand.position = new PIXI.Point(Common.STAGE_WIDTH * 0.5, Common.STAGE_HEIGHT * 0.5);
    else if (this._state == this.STATE.TOOL)
        this._tutorialHand.position = Common.game.hud.getBrushBtnPosition();
    else if (this._state == this.STATE.PALETTE)
        this._tutorialHand.position = Common.game.hud.getPaletteBtnPosition();
};

//===================================================
//
// Private
//
//===================================================

Tutorial.prototype._processEvents = function () {
    for (var tutorialEvent of this._arrEvent) {
        switch (tutorialEvent) {
            case CommonGame.TUT_EVENT.CANVAS_VISIBLE:
            {
                this._arrTutorialStep[this.STATE.DRAW].isValid = true;

                break;
            }

            case CommonGame.TUT_EVENT.PALETTE_SELECTED:
            {
                if (this._state == this.STATE.DRAW
                    || this._state == this.STATE.TOOL)
                    this._hideHand();
                else if (this._state == this.STATE.PALETTE) {
                    this._hideHand(this._checkTutorialEnd);

                    this._state = this.STATE.IDLE;
                }

                if (Common.savedData.isPaletteTutorial) {
                    this._arrTutorialStep[this.STATE.PALETTE].isDone = true;

                    Common.savedData.isPaletteTutorial = false;
                    Common.savedData.save();
                }

                this._isPaused = true;
                this._tutorialStepTimer = 0;

                break;
            }

            case CommonGame.TUT_EVENT.MENU_PANEL_SHOWN:
            {
                if (this._state != this.STATE.IDLE)
                    this._hideHand();

                this._isPaused = true;
                this._tutorialStepTimer = 0;

                break;
            }

            case CommonGame.TUT_EVENT.MENU_PANEL_HIDDEN:
            case CommonGame.TUT_EVENT.PALETTE_PANEL_HIDDEN:
            {
                if (this._state != this.STATE.IDLE)
                    this._showHand();

                this._isPaused = false;
                this._tutorialStepTimer = 0;

                break;
            }

            case CommonGame.TUT_EVENT.PALETTE_BUTTON_ENABLED:
            {
                this._arrTutorialStep[this.STATE.PALETTE].isValid = true;

                if (this._state == this.STATE.PALETTE)
                    this._showHand();

                break;
            }

            case CommonGame.TUT_EVENT.PALETTE_BUTTON_DISABLED:
            {
                this._arrTutorialStep[this.STATE.PALETTE].isValid = false;

                if (this._state == this.STATE.PALETTE)
                    this._hideHand();

                break;
            }

            case CommonGame.TUT_EVENT.TOOL_SELECTED:
            {
                if (this._state == this.STATE.TOOL) {
                    this._hideHand(this._checkTutorialEnd);

                    this._state = this.STATE.IDLE;
                }

                if (Common.savedData.isToolTutorial) {
                    this._arrTutorialStep[this.STATE.TOOL].isDone = true;

                    Common.savedData.isToolTutorial = false;
                    Common.savedData.save();
                }

                this._tutorialStepTimer = 0;

                break;
            }

            case CommonGame.TUT_EVENT.CANVAS_DRAWN:
            {
                if (this._state == this.STATE.DRAW) {
                    this._hideHand(this._checkTutorialEnd);

                    this._state = this.STATE.IDLE;
                }

                if (Common.savedData.isDrawTutorial) {
                    this._arrTutorialStep[this.STATE.DRAW].isDone = true;

                    Common.savedData.isDrawTutorial = false;
                    Common.savedData.save();
                }

                this._tutorialStepTimer = 0;

                break;
            }
        }
    }

    this._arrEvent = [];
};

Tutorial.prototype._showHand = function () {
    TweenMax.to(this._tutorialHand, 0.25, {alpha: 1});
};

Tutorial.prototype._hideHand = function (onComplete) {
    var tm = TweenMax.to(this._tutorialHand, 0.25, {alpha: 0});

    if (onComplete != null)
        tm.eventCallback("onComplete", onComplete, null, this);
};

Tutorial.prototype._checkTutorialEnd = function () {
    if (!Common.savedData.isDrawTutorial && !Common.savedData.isToolTutorial && !Common.savedData.isPaletteTutorial)
        this.signals.onCompleted.dispatch();
};


//===================================================
//
// Events
//
//===================================================

// TODO:


//===================================================
//
// Getters / Setters
//
//===================================================

// TODO: